import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import AddCircleIcon from '@mui/icons-material/AddCircle';

interface Props {
  onClick: () => void;
}

function AddVehiclesButton({ onClick }: Props): JSX.Element {
  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
      <Tooltip title="Добавить ТС" placement="top">
        <IconButton sx={{ padding: 0, marginRight: '4px' }} color="primary" onClick={onClick}>
          <AddCircleIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

AddVehiclesButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AddVehiclesButton;
